import { LightbulbOffOutlineIcon } from './LightbulbOffOutlineIcon';

/**
 * author: Hans Böhm
 * id 02757DC7-3D66-4244-B115-C69A74D24B66
 * name lightbulb-off-outline
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-off-outline.svg
 * tags
 * - Home Automation 
 */
export const BulbOffOutlineIcon = LightbulbOffOutlineIcon;
export default BulbOffOutlineIcon